import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z",
		stroke: "currentColor",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.9375 13.5001C2.55184 12.4358 3.43552 11.552 4.49972 10.9375C5.56392 10.323 6.77113 9.99951 8 9.99951C9.22887 9.99951 10.4361 10.323 11.5003 10.9375C12.5645 11.552 13.4482 12.4358 14.0625 13.5001",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUser;
